import { render, staticRenderFns } from "./NsTopnavSection.vue?vue&type=template&id=611719a4&scoped=true&"
import script from "./NsTopnavSection.vue?vue&type=script&lang=js&"
export * from "./NsTopnavSection.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavSection.vue?vue&type=style&index=0&id=611719a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611719a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611719a4')) {
      api.createRecord('611719a4', component.options)
    } else {
      api.reload('611719a4', component.options)
    }
    module.hot.accept("./NsTopnavSection.vue?vue&type=template&id=611719a4&scoped=true&", function () {
      api.rerender('611719a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavSection.vue"
export default component.exports